import * as React from 'react';

interface IModalContextData {
    handleCloseButtonMounted: () => void;
    handleCloseButtonUnMounted: () => void;
    isCloseButtonMounted: () => boolean;
    closeButtonClickHandler?: React.MouseEventHandler;
}

/**
 * Modal context is being used in order to track information about all 'close' buttons inside the modal window.
 * If modal window doesn't have any close button inside - it is not supposed
 * to be closeable implicitly (e.g. by pressing 'esc' or by clicking on overlay behind modal).
 * Since buttons can be added/removed from react tree dynamically - keeping track of theirs count is neccessary
 */
class ModalContextData implements IModalContextData {
    private closeButtonsMountedNumber = 0;

    public closeButtonClickHandler: React.MouseEventHandler;

    public handleCloseButtonMounted = () => {
        this.closeButtonsMountedNumber++;
    };

    public handleCloseButtonUnMounted = () => {
        this.closeButtonsMountedNumber--;
    };

    public isCloseButtonMounted = () => {
        return this.closeButtonsMountedNumber > 0;
    };
}

const ModalContext = React.createContext<IModalContextData>(null);

export { ModalContext, ModalContextData, IModalContextData };